import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";

export function initImageGallery(): void {
  const galleries = document.querySelectorAll<HTMLElement>(
    ".hwk-blocks--image-gallery.pswp-gallery",
  );

  if (galleries.length === 0) return;

  galleries.forEach((gallery) => {
    const lightbox = new PhotoSwipeLightbox({
      gallery,
      children: "a",
      pswpModule: () => import("photoswipe"),
    });

    lightbox.on("uiRegister", function () {
      lightbox.pswp?.ui?.registerElement({
        name: "custom-caption",
        order: 9,
        isButton: false,
        appendTo: "root",
        onInit: (el, pswp) => {
          pswp.on("change", () => {
            const caption =
              pswp.currSlide?.data?.element?.dataset?.caption ?? "";
            el.className = "pswp__custom-caption";
            el.textContent = caption;
            el.style.display = caption ? "" : "none";
          });
        },
      });
    });

    lightbox.init();
  });
}
